<script setup>
import { computed } from 'vue'
import { Typography } from '@aryeo/runway'
import { useMediaRequests } from '@/Hooks/Company/useMediaRequests.js'
import { pluralize } from '@/Utils/StringFormatter.js'
import { useAuth } from '@/Hooks/Company/useAuth.js'

import SimpleAlert from '@/Runway/Alerts/Simple.vue'

const { authCompanyUser } = useAuth()
const { pendingMediaRequestsForPhotographerCount } = useMediaRequests()

const props = defineProps({
  inSidebar: {
    type: Boolean,
    default: false,
  },
})

const mediaRequestDescription = computed(() => {
  return pendingMediaRequestsForPhotographerCount > 1
    ? 'You’ve received multiple media requests to assign to an existing company or create a new company to handle the requests.'
    : `You’ve received a media request to ${authCompanyUser.value.email}. Assign this request to an existing company or create a new company to handle the request.`
})
</script>

<template>
  <SimpleAlert
    v-if="pendingMediaRequestsForPhotographerCount > 0"
    class="break-words"
    :class="{ 'mx-6': inSidebar }"
    type="info"
    :title="`${pendingMediaRequestsForPhotographerCount} unassigned ${pluralize(pendingMediaRequestsForPhotographerCount, 'media request', 'media requests')}`"
    :hide-icon="true"
    :description="mediaRequestDescription"
  >
    <Typography as="p">
      <a
        :href="route('web.company.media-requests.manage.index')"
        class="mt-4 font-medium text-info whitespace-nowrap hover:text-info-dark"
      >
        Assign {{ pluralize(pendingMediaRequestsForPhotographerCount, 'request', 'requests') }}
        <span aria-hidden="true">&rarr;</span>
      </a>
    </Typography>
  </SimpleAlert>
</template>
